module.exports = __webpack_public_path__ + "static/img/huanggua.216a4b9d.png";